import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import { SnackbarService, Vue3Snackbar } from 'vue3-snackbar'
import 'vue3-snackbar/styles'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import { useAuthStore } from './stores/auth'
import { getElementPlusLocale, setElementPlusApp, updateElementPlusLocale } from './utils/elementPlusLocale'
import './assets/base.css'
import { setupSentry } from './sentry'

const app = createApp(App)

const pinia = createPinia()
setupSentry(app, pinia)

app.use(pinia)
app.use(SnackbarService)
app.component('vue3-snackbar', Vue3Snackbar)

// Get the user's default language or use 'en' as default
const getUserLanguage = () => {
  // Try to get user language from localStorage if user is logged in. Admin and
  // reception sessions live under separate keys (see stores/auth.ts) so both can
  // be logged in independently in the same browser — pick the pair for the zone
  // this page load is actually in.
  const isRcp = window.location.pathname.startsWith('/rcp/')
  const authToken = localStorage.getItem(isRcp ? 'rcpAuthToken' : 'authToken')
  let userLanguage = 'en'

  if (authToken) {
    try {
      const savedUser = localStorage.getItem(isRcp ? 'rcpUser' : 'user')
      if (savedUser) {
        const user = JSON.parse(savedUser)
        userLanguage = user.defaultLang || 'en'
      }
    } catch (e) {
      console.warn('Failed to parse saved user data:', e)
      userLanguage = 'en'
    }
  }

  return userLanguage
}

app.use(ElementPlus, {
  locale: getElementPlusLocale(getUserLanguage()),
})

// Store app instance for dynamic locale updates
setElementPlusApp(app)

app.use(i18n)
app.use(router)
app.mount('#app')
